"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandConfig = exports.brandConfigs = void 0;
var defaultConfig = {
    key: 'default',
    links: {
        top: 'https://www.machi-ene.jp/',
    },
    hiddenContactTypes: [],
    showCompany: false,
};
exports.brandConfigs = {
    evee: {
        key: 'evee',
        links: {
            top: 'https://evee.energy',
        },
        hiddenContactTypes: [],
        showCompany: false,
    },
    honda: {
        key: 'honda',
        links: {
            top: 'https://www.machi-ene.jp/hondadenki/inquiry/',
        },
        hiddenContactTypes: ['5', '6'],
        showCompany: false,
    },
    corporate: {
        key: 'corporate',
        links: {
            top: 'https://www.retailenergy.co.jp/',
        },
        hiddenContactTypes: ['5', '6'],
        showCompany: true,
    },
};
function getBrandConfig(target) {
    if (!target || !exports.brandConfigs[target]) {
        return exports.brandConfigs['evee'] || defaultConfig;
    }
    return exports.brandConfigs[target];
}
exports.getBrandConfig = getBrandConfig;
